'use strict';

// Geometry of a click-and-drag over the empty grid: which cells the pointer has
// swept, expressed as a [startMin, endMin) range on the day.

function floorTo(minutes, snapMinutes) {
  return Math.floor(minutes / snapMinutes) * snapMinutes;
}

// The cells swept from the press (anchor) to the current pointer position, in
// whole `snapMinutes` cells, whichever direction the pointer went. Both ends
// stay inside the visible hours (`endHour` is the last row, so the grid ends an
// hour after it).
function selectionRange(anchorMin, pointerMin, snapMinutes, startHour, endHour) {
  const gridStart = startHour * 60;
  const gridEnd = (endHour + 1) * 60;

  const clamp = (m) => Math.max(gridStart, Math.min(gridEnd - snapMinutes, m));
  const a = clamp(floorTo(anchorMin, snapMinutes));
  const c = clamp(floorTo(pointerMin, snapMinutes));

  return {
    startMin: Math.min(a, c),
    endMin: Math.max(a, c) + snapMinutes,
  };
}

// Cut the range down to the free gap around `anchorMin`, so a selection swept
// across an existing block stops at its edge instead of covering it. `busy` is
// a list of { from, to } minute ranges. Returns null when the anchor itself is
// inside a block.
function clampRangeToGap(range, busy, anchorMin) {
  let gapStart = 0;
  let gapEnd = 24 * 60;

  for (const slot of busy) {
    if (anchorMin >= slot.from && anchorMin < slot.to) return null;
    if (slot.to <= anchorMin && slot.to > gapStart) gapStart = slot.to;
    if (slot.from > anchorMin && slot.from < gapEnd) gapEnd = slot.from;
  }

  const startMin = Math.max(range.startMin, gapStart);
  const endMin = Math.min(range.endMin, gapEnd);
  if (endMin <= startMin) return null;

  return { startMin, endMin };
}

module.exports = { selectionRange, clampRangeToGap };
